// extracted by mini-css-extract-plugin
export default {"main":"Status_main__Q1TrP","active":"Status_active__e50Vi","upcoming":"Status_upcoming__sqyOg","closed":"Status_closed__Cud13"};